import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Modal from "@mui/material/Modal";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../styles/logo.css";
import { Header } from "../header";
import { Container } from "@mui/material";
import Swal from "sweetalert2";
import {
  useLoginStore,
  usePektaStore,
  usePengajianStore,
  useTauliah,
} from "../helpers/state";
import PektaHeader from "../helpers/pektaHeader";

toast.configure();

export function PektaForm4() {
  const { login } = useLoginStore();
  const { pektaData, otherPektaData, nextPage } = usePektaStore();
  const { kelayakan } = usePengajianStore();
  const { tauliah } = useTauliah();
  const [open, setOpen] = useState(false);

  var CryptoJS = require("crypto-js");
  let marital;

  function marriage() {
    if (pektaData.tarafKahwin === "BUJANG") {
      marital = "single";
    } else if (pektaData.tarafKahwin === "KAHWIN") {
      marital = "married";
    } else if (pektaData.tarafKahwin === "DUDA") {
      marital = "widower";
    } else if (pektaData.tarafKahwin === "JANDA") {
      marital = "widow";
    }
  }

  const [checked, setChecked] = useState(Boolean(false));
  let navigate = useNavigate();
  const bytes = CryptoJS.AES.decrypt(
    login.jwtToken,
    `${process.env.SECRET_KEY}`
  );
  var userToken = bytes.toString(CryptoJS.enc.Utf8);

  const userId = login.id;
  let pektaId;
  let data, addressData, accCreated, dt;
  let currentDt = new Date();
  const processedDt = moment(currentDt).format("YYYY-MM-DD");
  if (pektaData) {
    marriage();

    // Build normalized qualification arrays from store state
    const kelayakanAll =
      kelayakan
        ?.map((qual) => ({
          category: qual.category,
          type: qual.type,
          level: qual.level,
          end_date: qual.yearPengajian,
          institution: qual.institution,
          cert_file: qual.qualificationID
            ? qual.qualificationID.toString()
            : null,
        }))
        .filter(
          (qual) => qual.type && qual.level && qual.end_date && qual.cert_file
        ) || [];

    const kelayakanAgama = kelayakanAll.filter(
      (qual) => qual.category === "AGAMA"
    );
    const kelayakanBukanAgama = kelayakanAll.filter(
      (qual) => qual.category !== "AGAMA"
    );

    // Backward-compatible pekta_qualification (without tawaran haji)
    let pektaQualification = []; //kelayakanAll.map(({ category, ...rest }) => rest);

    // Add tauliah qualification only if it has valid data
    if (tauliah.tarikhMula && tauliah.tarikhAkhir && tauliah.tauliahID) {
      pektaQualification.push({
        type: "Sijil Tauliah Mengajar Agama Negeri",
        start_date: tauliah.tarikhMula,
        end_date: tauliah.tarikhAkhir,
        cert_file: tauliah.tauliahID.toString(),
        state: tauliah.tauliahNegeri,
      });
    }

    // tawaran_haji as its own object (do not include in pekta_qualification)
    const tawaranHaji =
      tauliah.hajiID && tauliah.hajiStatus == "Telah Menunaikan Haji"
        ? [
            {
              haji_status: "yes",
              end_date: tauliah.tahunHaji,
              cert_file: tauliah.hajiID.toString(),
              mutawif_cert_file: tauliah.mutawifID.toString(),
            },
          ]
        : [
            {
              haji_status: "no",
              mutawif_cert_file: tauliah.mutawifID.toString(),
            },
          ];

    // Add SPIH qualification only if it has valid data
    if (tauliah.spihID && tauliah.tahunSPIH) {
      pektaQualification.push({
        type: "Sijil Pembimbing Ibadat Haji",
        end_date: tauliah.tahunSPIH,
        cert_file: tauliah.spihID.toString(),
      });
    }

    data = JSON.stringify({
      data: {
        status: "pending",
        nric: pektaData.kadPengenalan,
        occupation: pektaData.sektorPekerjaan,
        occupation_name: pektaData.pekerjaan,
        employer_name: otherPektaData?.namaMajikan,
        employer_address: otherPektaData?.alamatMajikan,
        phone_number: pektaData.noTel,
        photo_file: pektaData.gambar.toString(),
        submitted_date: processedDt,
        nation: "MALAYSIA",
        marital_status: marital,
        citizen: pektaData.warganegara,
        th_account: pektaData.akaunTH,
        bank_account_number: pektaData.akaunBank,
        bank_name: pektaData.namaBank,
        phone_home: otherPektaData.noRumah,
        phone_office: otherPektaData.noPejabat,
        pekta_qualification: pektaQualification,
        kelayakan_agama: kelayakanAgama,
        kelayakan_bukan_agama: kelayakanBukanAgama,
        tawaran_haji: tawaranHaji,
      },
    });

    addressData = JSON.stringify({
      data: {
        user: userId,
        address_type: `Personal Address for User: ${userId}`,
        street: pektaData.alamat,
        city: pektaData.bandar,
        state: pektaData.negeri,
        postcode: pektaData.poskod,
      },
    });
  }

  let applicationConfig = {
    method: "post",
    url: `${process.env.REACT_APP_API_URL}/api/pekta-applications/`,
    headers: {
      Authorization: `Bearer ${userToken}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let addressConfig = {
    method: "post",
    url: `${process.env.REACT_APP_API_URL}/api/user-addresses`,
    headers: {
      Authorization: `Bearer ${userToken}`,
      "Content-Type": "application/json",
    },
    data: addressData,
  };

  useEffect(() => {
    if (!pektaData.firstName) {
      toast.warning(`Sila pergi ke borang muka pertama`, {
        position: toast.POSITION.TOP_CENTER,
      });
      navigate("/myprofile");
    }
  }, [checked, navigate, pektaData.firstName]);

  const handleChange = (e) => {
    setChecked(Boolean(e.target.checked));
  };

  function submitOnClick() {
    setOpen(true); // Show loader at the beginning
    let roleConfig = {
      method: "put",
      url: `${process.env.REACT_APP_API_URL}/api/users/${userId}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
        "Content-Type": "application/json",
      },
      data: {
        full_name: pektaData.firstName.toUpperCase(),
        gender: pektaData.jantina,
        age: pektaData.umur,
        phone_mobile: pektaData.noTel,
      },
    };

    axios(roleConfig)
      .then((result) => {
        dt = new Date(result.data.createdAt);
        dt.setFullYear(dt.getFullYear() + 1);
        accCreated = moment(dt).format("YYYY-MM-DD");
        axios(applicationConfig)
          .then((response) => {
            let pektaAppId = response.data.data.id;
            let pektaConfig = {
              method: "post",
              url: `${process.env.REACT_APP_API_URL}/api/pektas/`,
              headers: {
                Authorization: `Bearer ${userToken}`,
                "Content-Type": "application/json",
              },
              data: {
                data: {
                  user: userId,
                  fullname: pektaData.firstName.toUpperCase(),
                  expiry_date: accCreated,
                  is_confirmed: true,
                  is_active: true,
                  pekta_applications: [pektaAppId],
                },
              },
            };

            axios(addressConfig)
              .then((response) => {
                let addressID = response.data.data.id;

                axios(pektaConfig)
                  .then((response) => {
                    pektaId = response.data.data.id;
                    let userConfig = {
                      method: "put",
                      url: `${process.env.REACT_APP_API_URL}/api/users/${userId}`,
                      headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json",
                      },
                      data: {
                        user_addresses: addressID,
                        pekta: pektaId,
                        id_no: pektaData.kadPengenalan,
                        address_line: pektaData.alamat,
                        district: pektaData.bandar,
                        state: pektaData.negeri,
                        postcode: pektaData.poskod,
                      },
                    };

                    axios(userConfig)
                      .then((response) => {
                        console.log("change user ok");
                        setOpen(false);
                        nextPage(5);
                      })
                      .catch((error) => {
                        console.log(
                          "An error occurred userConfig:",
                          error.response
                        );
                        setOpen(false);
                      });
                  })
                  .catch((error) => {
                    console.log("An error occurred pekta:", error.response);
                    setOpen(false);
                  });
              })
              .catch((error) => {
                console.log("An error occurred address:", error.response);
                setOpen(false);
              });
          })
          .catch((error) => {
            Swal.fire("data null");
            console.log("An error occurred application:", error.response);
            setOpen(false);
          });
      })
      .catch((error) => {
        toast.warning(`Dokumen gagal dimuat naik, sila cuba semula.`, {
          position: toast.POSITION.TOP_CENTER,
        });
        console.log("An error occurred role:", error.result);
        setOpen(false);
      });
  }
  return (
    <div>
      <Header />

      <PektaHeader page={"4"} />

      <Container maxWidth={false} disableGutters>
        <div className="bg-gray-50 w-full h-full overflow-y-auto">
          <div className="mx-2 md:mx-10 pb-5 bg-white rounded">
            <div className="mx-2 md:mx-5 mt-5 bg-white p-2">
              <p className="text-xl md:text-4xl">Pengakuan Pemohon</p>

              <p className="my-3 md:my-5 mr-2 md:mr-5 text-justify text-xs md:text-base">
                Saya mengaku bahawa semua keterangan yang telah saya nyatakan di
                dalam borang ini adalah benar. Saya sedar bahawa sekiranya ada
                di antara maklumat itu didapati tidak tepat/palsu, permohonan
                saya boleh dibatalkan. Sekiranya saya dilantik, perkhidmatan
                saya boleh ditamatkan dengan serta-merta oleh Pengarah Urusan
                Kumpulan dan Ketua Pegawai Eksekutif, Lembaga Tabung Haji
              </p>

              <p className="my-3 md:my-5 mr-2 md:mr-5 text-justify text-xs md:text-base font-semibold">
                Syarat-syarat permohonan PEKTA
              </p>
              <ol className="list-decimal ml-6 text-xs md:text-base mb-4">
                <li>
                  Telah menunaikan fardhu haji atau berpengalaman sebagai
                  mutawwif umrah
                </li>
                <li>Berumur tidak melebihi 55 tahun</li>
                <li>
                  Mempunyai tauliah mengajar yang sah dan masih berkuatkuasa
                  dari Pihak Berkuasa Agama Islam Negeri
                </li>
                <li>
                  Mempunyai latar belakang Pengajian Islam dengan kelulusan
                  sekurang-kurangnya Diploma / Sijil Tinggi Agama Malaysia
                  (STAM) / STPM / sijil-sijil pengajian Islam yang diiktiraf.
                </li>
              </ol>

              <label className="pt-3 md:pt-5">
                <input
                  id="acknowledge"
                  type={"checkbox"}
                  defaultChecked={checked}
                  onChange={handleChange}
                />{" "}
                Saya Setuju
              </label>
            </div>

            <div className="text-center sm:mx-24 my-16 px-3 flex justify-between">
              <button
                className="border-2 bg-green-600 text-white rounded-lg p-2"
                onClick={() => {
                  nextPage(3);
                }}
              >
                ❮ Kembali
              </button>
              <button
                disabled={!checked}
                className={`px-4 py-2 text-white rounded-lg ${
                  checked
                    ? "bg-green-600 hover:bg-green-700 cursor-pointer"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }`}
                onClick={submitOnClick}
              >
                Seterusnya ❯
              </button>
            </div>
          </div>
        </div>
      </Container>
      <Modal
        open={open}
        onClose={() => console.log("check")}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="flex justify-center md:mt-40 lg:mt-48 xl:mt-56">
          <CircularProgress color="success" size={200} />
        </div>
      </Modal>
    </div>
  );
}
